export default __webpack_public_path__ + "static/festl-brass-fenzl-preview-a136e476d75dc3c23b5cc118bfdb61f5.jpg";